import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14 12v-1.332l-2-2c-.619-.595-1.381-.595-2 0l-.667.667-2-2c-.618-.596-1.381-.596-2 0L2 10.668V12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.333",
      d: "M10 5.333h.007M14 12V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8m12 0a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2m12 0v-1.332l-2-2c-.619-.595-1.381-.595-2 0l-.667.667-2-2M2 12v-1.332l3.333-3.333c.619-.596 1.382-.596 2 0m0 0 3.334 3.333"
    }, null, -1)
  ])))
}
export default { render: render }